<template>
    <el-dialog :visible.sync="isShow" v-dialogDrag :modal="true" :close-on-click-modal="true"
        :close-on-press-escape="true" :show-close="true" width="420px" custom-class="user-profile-dialog"
        :before-close="close" title="个人资料">
        <div class="user-profile-card">
            <!-- 用户头像和基本信息 -->
            <div class="profile-header">
                <div class="avatar-section">
                    <head-image :size="80" :url="userInfo.headImageThumb" radius="50%"
                        :name="userInfo.nickName"></head-image>
                </div>
                <div class="user-info-content">
                    <h3 class="user-name">{{ userInfo.nickName }}</h3>
                    <p class="user-id">ID: {{ userInfo.userName }}</p>
                    <div class="user-status">
                        <span class="status-dot online"></span>
                        <span class="status-text">在线</span>
                    </div>
                </div>
            </div>

            <!-- 详细信息 -->
            <div class="profile-details">
                <div class="detail-item" v-if="userInfo.companyName">
                    <div class="detail-label">
                        <i class="el-icon-office-building"></i>
                        <span>企业</span>
                    </div>
                    <div class="detail-value">
                        {{ userInfo.companyName }}
                    </div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">
                        <i class="el-icon-user"></i>
                        <span>性别</span>
                    </div>
                    <div class="detail-value">
                        {{ userInfo.sex === 0 ? '男' : userInfo.sex === 1 ? '女' : '未设置' }}
                    </div>
                </div>

                <div class="detail-item" v-if="userInfo.phone">
                    <div class="detail-label">
                        <i class="el-icon-phone"></i>
                        <span>手机号</span>
                    </div>
                    <div class="detail-value">
                        {{ userInfo.phone }}
                    </div>
                </div>

                <div class="detail-item" v-if="userInfo.email">
                    <div class="detail-label">
                        <i class="el-icon-message"></i>
                        <span>邮箱</span>
                    </div>
                    <div class="detail-value">
                        {{ userInfo.email }}
                    </div>
                </div>

                <div class="detail-item signature-item">
                    <div class="signature-label">
                        <i class="el-icon-edit"></i>
                        <span>个性签名</span>
                    </div>
                    <div class="signature-content" v-if="userInfo.signature">
                        {{ userInfo.signature }}
                    </div>
                    <div class="signature-empty" v-else @click="goToPersonalSettings">
                        <div class="empty-icon">
                            <i class="el-icon-edit-outline"></i>
                        </div>
                        <div class="empty-text">
                            <p class="empty-title">还没有个性签名</p>
                            <p class="empty-desc">去个人设置中编辑你的个性签名吧</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </el-dialog>
</template>

<script>
import HeadImage from './HeadImage.vue';

export default {
    name: "UserProfileCard",
    components: {
        HeadImage
    },
    data() {
        return {
            isShow: false,
        }
    },
    methods: {
        open() {
            this.isShow = true;
        },
        close() {
            this.isShow = false;
        },
        goToPersonalSettings() {
            this.close();
            // 检查当前路由，避免重复跳转
            if (this.$route.path !== '/home/setting') {
                this.$router.push('/home/setting');
            } else {
                // 如果已经在设置页面，切换到个人资料tab
                this.$nextTick(() => {
                    // 通过事件总线通知Setting组件切换到个人资料tab
                    this.$eventBus.$emit('switchToPersonalInfo');
                });
            }
        }
    },
    computed: {
        userInfo() {
            return this.userStore.userInfo || {};
        }
    }
}
</script>

<style scoped lang="scss">
.user-profile-card {
    padding: 0;
    background: transparent;
    border-radius: var(--radius-lg);
    overflow: hidden;
    animation: fadeInUp 0.4s ease-out;

    .profile-header {
        padding: 18px 14px 22px;
        display: flex;
        align-items: center;
        gap: 20px;
        position: relative;
        border-radius: var(--radius-lg);
        background:
            radial-gradient(80% 100% at 0% 0%, rgba(91, 141, 238, 0.10) 0%, transparent 60%),
            radial-gradient(80% 100% at 100% 0%, rgba(168, 139, 255, 0.10) 0%, transparent 60%),
            linear-gradient(180deg, rgba(255, 252, 243, 0.40), rgba(255, 252, 243, 0.20));

        // 顶部 Aurora 装饰条
        &::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0;
            height: 2px;
            background: linear-gradient(90deg,
                var(--aurora-blue) 0%,
                var(--aurora-purple) 35%,
                var(--aurora-pink) 65%,
                var(--aurora-gold) 100%);
            opacity: 0.7;
        }

        .avatar-section {
            flex-shrink: 0;
            position: relative;
            z-index: 10;
            border-radius: 50%;
            padding: 2px;
            background: conic-gradient(from 0deg,
                var(--aurora-blue),
                var(--aurora-purple),
                var(--aurora-pink),
                var(--aurora-gold),
                var(--aurora-platinum),
                var(--aurora-blue));
            box-shadow:
                0 4px 14px rgba(91, 141, 238, 0.28),
                0 0 24px rgba(168, 139, 255, 0.18);

            :deep(.head-image) .avatar-image,
            :deep(.head-image) .avatar-text {
                border: 2px solid #fff;
            }
        }

        .user-info-content {
            flex: 1;
            position: relative;
            z-index: 10;

            .user-name {
                margin: 0 0 6px 0;
                font-size: 22px;
                font-weight: 700;
                letter-spacing: -0.4px;
                color: var(--im-text-color);
                line-height: 1.2;
                display: block;
            }

            .user-id {
                margin: 0 0 10px 0;
                font-size: 13px;
                font-weight: 500;
                font-family: 'SF Mono', 'Monaco', 'Menlo', 'Courier New', monospace;
                color: var(--im-text-color-lighter);
                line-height: 1.3;
                display: block;
                letter-spacing: -0.1px;
            }

            .user-status {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 4px 12px 4px 8px;
                background: rgba(52, 199, 89, 0.10);
                border: 0.5px solid rgba(52, 199, 89, 0.28);
                border-radius: 999px;
                width: fit-content;

                .status-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    animation: pulse 2s infinite;

                    &.online {
                        background: linear-gradient(135deg, #4FE07A, #34C759);
                        box-shadow: 0 0 8px rgba(52, 199, 89, 0.6);
                    }
                }

                .status-text {
                    font-size: 12px;
                    font-weight: 600;
                    color: var(--im-color-success);
                    letter-spacing: -0.1px;
                }
            }
        }
    }

    .profile-details {
        margin: 12px 0 0;
        padding: 0 8px;

        .detail-item {
            display: flex;
            align-items: flex-start;
            padding: 14px 10px;
            border-bottom: 0.5px solid var(--hairline-soft);
            transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);
            border-radius: var(--radius-sm);
            margin-bottom: 2px;

            &:hover {
                background: rgba(91, 141, 238, 0.06);
                transform: translateX(2px);
            }

            &:last-child {
                border-bottom: none;
                margin-bottom: 0;
            }

            .detail-label {
                display: flex;
                align-items: center;
                gap: 10px;
                width: 96px;
                font-weight: 500;
                color: var(--im-text-color-lighter);
                font-size: 13px;
                flex-shrink: 0;

                i {
                    color: var(--aurora-blue);
                    font-size: 16px;
                    width: 22px;
                    text-align: center;
                }
            }

            .detail-value {
                flex: 1;
                font-size: 14px;
                color: var(--im-text-color);
                word-break: break-all;
                font-weight: 500;
                line-height: 1.5;
                letter-spacing: -0.2px;
            }
        }

        // 个性签名特殊样式
        .signature-item {
            flex-direction: column;
            align-items: flex-start;
            padding: 14px 10px 16px;

            &:hover { transform: none; background: transparent; }

            .signature-label {
                display: flex;
                align-items: center;
                gap: 10px;
                font-weight: 500;
                color: var(--im-text-color-lighter);
                font-size: 13px;
                margin-bottom: 10px;

                i {
                    color: var(--aurora-purple);
                    font-size: 16px;
                    width: 22px;
                    text-align: center;
                }
            }

            .signature-content {
                width: 100%;
                font-size: 14px;
                color: var(--im-text-color);
                line-height: 1.6;
                font-style: italic;
                padding: 12px 14px;
                border-radius: var(--radius-md);
                background:
                    linear-gradient(135deg, rgba(91, 141, 238, 0.06), rgba(168, 139, 255, 0.06));
                border: 0.5px solid rgba(91, 141, 238, 0.18);
                word-break: break-word;
                position: relative;
                box-sizing: border-box;
            }

            .signature-empty {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 14px;
                background: rgba(255, 252, 243, 0.45);
                padding: 16px 18px;
                border-radius: var(--radius-md);
                border: 0.5px dashed rgba(91, 141, 238, 0.32);
                transition: all 0.24s ease;
                cursor: pointer;
                box-sizing: border-box;

                &:hover {
                    border-color: rgba(91, 141, 238, 0.55);
                    background: rgba(91, 141, 238, 0.06);
                    transform: translateY(-1px);
                    box-shadow: 0 4px 14px rgba(91, 141, 238, 0.12);
                }

                .empty-icon {
                    flex-shrink: 0;
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, rgba(91, 141, 238, 0.16), rgba(168, 139, 255, 0.12));
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i { font-size: 18px; color: var(--aurora-blue); }
                }

                .empty-text {
                    flex: 1;

                    .empty-title {
                        margin: 0 0 4px 0;
                        font-size: 14px;
                        font-weight: 600;
                        color: var(--im-text-color);
                    }

                    .empty-desc {
                        margin: 0;
                        font-size: 12px;
                        color: var(--im-text-color-lighter);
                        line-height: 1.4;
                    }
                }
            }
        }
    }
}

// 添加动画效果
@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.7);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(103, 194, 58, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(103, 194, 58, 0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
